import EventSearchResultsAsync from './EventSearchResultsAsync';

export default EventSearchResultsAsync;
